import { DOCUMENT, inject, InjectionToken } from '@angular/core';

import { environment } from '../environments/environment';

/**
 * Where unimarket-api is.
 *
 * In production that is the storefront's own origin, written out rather than left relative. The
 * transfer cache keys an answer by its full address, so the browser finds what the server already
 * fetched only if both name the same one.
 */
export const API_URL = new InjectionToken<string>('API_URL', {
  providedIn: 'root',
  factory: () => environment.apiUrl || inject(DOCUMENT).location.origin
});
